import { Component, Input, Output, OnInit, EventEmitter, inject } from '@angular/core';
import { Events, Steps, TrackingItem, TrackingObjects } from '../models/trakingObjects';
import { FunctionsService } from 'src/app/data/functions.service';
import { finalize } from 'rxjs';
import { TimeNegotiationValidate } from 'src/app/validators/time-negotiation';
import { FirebaseService } from 'src/app/commons/firebase.service';
import { ReviewModalComponent, ReviewService } from '../review-modal/review-modal.component';
import { DialogModule } from 'primeng/dialog';
import { CoreModule } from '../core.module';

@Component({
  selector: 'app-accordion-shopping',
  templateUrl: './accordion-shopping.component.html',
  styleUrls: ['./accordion-shopping.component.css'],
})
export class AccordionShoppingComponent implements OnInit {
  @Input() negociacoes: any[];
  @Output() detalhes = new EventEmitter<any>();
  @Output() detalhesCompra = new EventEmitter<any>();
  @Output() openModalReview = new EventEmitter<any>();
  @Output() confirmWithdraw = new EventEmitter<any>();
  rastreio: TrackingObjects[] = [];
  trackingItems: TrackingItem[] = [];
  statusStyles: {} = {
    'pagamento_nao_processado': 'badge badge-secondary',
    'pagamento_recusado': 'badge badge-secondary',
    'falha_pagamento': 'badge bg-danger',
    'pagamento_cancelado': 'badge bg-danger',
    'aguardando_pagamento': 'badge bg-warning',
    'pagamento_aprovado': 'badge bg-success',
  }

  statusTile: {} = {
    'pagamento_falho': 'pagamento_falho',
    'pagamento_recusado': 'pagamento_recusado',
    'falha_pagamento': 'falha_pagamento',
    'aguardando_pagamento': 'pagamento_aguardando',
    'pagamento_aprovado': 'pagamento_aprovado',
    'pagamento_cancelado': 'pagamento_cancelado',
  }
  steps: Steps[] = [];
  currentStep: any = 0;
  prePostagem: any[];
  titleCase: { [key: string]: string } = {
    'delivered': 'Entregue',
    'in-transit': 'Em trânsito',
    'arrived': 'Chegou ao país de destino: Brasil',
    'on-the-way': 'A caminho do país de destino: Brasil',
    'processing-external': 'Processamento no exterior',
    'processing': 'Preparando o pedido',
    'created': 'Pedido Postado'
  };
  statusEventsTile: { [key: string]: string } = {
    'Objeto entregue ao destinatário': 'delivered',
    'Objeto saiu para entrega ao destinatário': 'in-transit',
    'Objeto em transferência - por favor aguarde': 'in-transit',
    'Objeto postado': 'created',
    'Objeto postado após o horário limite da unidade': 'created',
  }

  statusColors: { [key: string]: string } = {
    'delivered': 'green',            // Entregue
    'in-transit': 'blue',            // Em trânsito
    'arrived': 'purple',             // Chegou ao país de destino: Brasil
    'on-the-way': 'orange',          // A caminho do país de destino: Brasil
    'processing-external': 'brown',  // Processamento no exterior
    'processing': '#ca5217',          // Preparando o pedido
    'created': 'gray'                // Pedido Criado
  };
  reviews: string[] = [
    'review_1',
    'review_2',
    'review_3',
    'review_4',
    'review_5'
  ];
  statusNegotiation: { [key: string]: string } = {
    'negociacao_expirada': 'EXPIRED',
    'negociado_sucesso': 'SUCCESS',
  }
  displayName: string;
  constructor(private functions: FunctionsService, public firebase: FirebaseService,
  ) { }

  private reviewService = inject(ReviewService);
  product = this.reviewService.product;

  ngOnInit(): void {

  }

  openModal(event) {
    console.log('event in accordion shopping', event)
    this.openModalReview.emit(event)
  }
  onDetalhesNegociacao(negociacao: any) {
    this.detalhes.emit(negociacao);
  }
  onDetalhesCompra(venda: any) {
    this.detalhesCompra.emit(venda);
  }

  tempoRestante(negociacao: any) {
    return TimeNegotiationValidate.validate(negociacao);
  }

  fetchSteps(venda: any, trackingObjects: Events[]): Steps[] {
    if (trackingObjects) {
      this.steps = [
        { title: 'pedido_realizado', date: venda?.data_criacao, icon: '...' },
        { title: 'pedido_pago', date: venda?.pagamento?.data || null, extra: venda?.valor_total, icon: '...' },
        { title: 'pedido_enviado', date: trackingObjects[trackingObjects?.length - 1]?.dtHrCriado, icon: '...' },
        { title: 'pedido_recebido', date: this.statusEventsTile[trackingObjects[0]?.descricao] === 'delivered' ? trackingObjects[0]?.dtHrCriado : null, icon: '...' },
        { title: 'pedido_avaliado', date: venda?.reviewed_at || null, icon: '...', toRating: this.statusEventsTile[trackingObjects[0]?.descricao] === 'delivered', rating: venda?.rating }
      ]
    }
    return this.steps
  }

  fetchCurrentStep(venda: any, trackingObjects: Events[]): number {
    const countSteps: number[] = [0, 0, 0, 0, 0]
    countSteps[1] = 1
    venda?.pagamento?.data && venda?.pagamento?.status !== 'aguardando_pagamento' && venda.pagamento.status !== 'pagamento_cancelado' && (countSteps[2] = 2)
    if (trackingObjects) {
      trackingObjects?.forEach(events => {
        if (this.statusEventsTile[events?.descricao] === 'created') (countSteps[3] = 3)
        if (this.statusEventsTile[events?.descricao] === 'delivered') (countSteps[4] = 4)
      })
      venda?.reviewed_at && (countSteps[5] = 5)
    }
    return Math.max(...countSteps);
  }

  fetchStepsReadyForPickUp(venda: any): Steps[] {
    this.steps = []
    this.steps = [
      { title: 'pedido_realizado', date: venda?.data_criacao, icon: 'assets/images/steps-package/pedido_realizado.jpg' },
      { title: 'pedido_pago', date: venda?.pagamento?.data || null, extra: venda?.pagamento?.data ? venda?.valor_total : null, icon: 'assets/images/steps-package/pedido_pago.jpg' },
      { title: 'retirada_disponivel', date: venda?.retirada?.pronto || null, icon: 'assets/images/steps-package/pedido_enviado.jpg' },
      { title: 'pedido_retirado', date: venda?.retirada?.retirado || null, icon: 'assets/images/steps-package/pedido_recebido.jpg' },
      { title: 'pedido_avaliado', date: venda?.reviewed_at || null, toRating: false, icon: 'assets/images/steps-package/pedido_avaliado.jpg' }
    ]

    return this.steps
  }
  fetchCureentStepReadyForPickup(venda: any): number {
    const countSteps: number[] = [0, 0, 0, 0, 0]
    countSteps[1] = 1
    venda?.pagamento?.data && venda.pagamento.status !== 'aguardando_pagamento' && venda.pagamento.status !== 'pagamento_cancelado' && (countSteps[2] = 2)
    venda?.retirada?.pronto && (countSteps[3] = 3)
    venda?.retirada?.retirado && (countSteps[4] = 4)
    venda?.reviewed_at && (countSteps[5] = 5)
    return Math.max(...countSteps)
  }

  setTimelineStatus(status: string): string {
    return this.titleCase[status] || ''
  }

  getStatusColor(status: string): string {
    return this.statusColors[status] || 'black';
  }

  getRatingDescription(rating) {
    return this.reviews[rating - 1];
  }
  fetchJSONToString(data) {
    return JSON.stringify(data)
  }

  confirmWithdrawOrder(sale_id: string) {
    this.functions.setSaleConfirmByClient({ sale_id }).pipe(
      finalize(() => {
        this.confirmWithdraw.emit(true)
      })
    ).subscribe({
      next(res) {
        if (res.body.message === 'sucesso') {
          alert('Você confirmou o a retirada do seu pedido!')
        }
      },
      error() {
        alert('Houve algum problema ao confirmar a retirada do seu pedido. Por favor tente mais tarde.')
      }
    })
  }

  openEvaluateProductDialog(ean: string) {
    this.reviewService.openWithEan(ean);
  }
}
